import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

export const Impressum = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back Button */}
        <Button
          onClick={() => navigate('/')}
          variant="outline"
          className="mb-8 border-2 border-black hover:bg-black hover:text-white"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Button>

        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-black mb-4">Impressum</h1>
          <div className="w-24 h-1 bg-gradient-to-r from-black to-[#00CCDD]"></div>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 space-y-8">
          <div>
            <h2 className="text-2xl font-bold text-black mb-4">THS Bauprojekte GmbH</h2>
            <p className="text-gray-700 leading-relaxed">
              Bornheimer Str. 127<br />
              53119 Bonn<br />
              Deutschland
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-black mb-3">Kontakt</h3>
            <p className="text-gray-700 leading-relaxed">
              <strong>Telefon:</strong> 0176 – 59885691<br />
              <strong>E-Mail:</strong> <a href="mailto:info@thsbauprojekte.de" className="text-[#00CCDD] hover:underline">info@thsbauprojekte.de</a><br />
              <strong>Website:</strong> <a href="https://www.ths-bauprojekte.de" className="text-[#00CCDD] hover:underline">www.ths-bauprojekte.de</a>
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-black mb-3">Vertreten durch:</h3>
            <p className="text-gray-700">Redon Thaqi, Geschäftsführer der THS Bauprojekte GmbH</p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-black mb-3">Registereintrag</h3>
            <p className="text-gray-700 leading-relaxed">
              Eingetragen im Handelsregister<br />
              <strong>Registergericht:</strong> Amtsgericht Bonn<br />
              <strong>Registernummer:</strong> HRB 30436
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-black mb-3">Umsatzsteuer-ID</h3>
            <p className="text-gray-700">
              <strong>USt-IdNr.:</strong> DE408252888
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-black mb-3">Steuernummer</h3>
            <p className="text-gray-700">224/5744/3015</p>
          </div>

          <div className="pt-6 border-t border-gray-200">
            <h3 className="text-xl font-bold text-black mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
            <p className="text-gray-700 leading-relaxed">
              THS Bauprojekte GmbH<br />
              Bornheimer Str. 127<br />
              53119 Bonn
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};